import { styles } from "@/mocks/blcomics";

export default function StyleGuide() {
  return (
    <section id="style-guide" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-widest text-primary-600">BL漫画画风推荐</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-900 md:text-4xl">八种高人气画风，各有各的美</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            不同画风带来完全不同的阅读体验。以下是我们梳理出的 BL 漫画常见画风，点击标签跳转画风库即可查看对应作品。
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {styles.map((s) => (
            <article
              key={s.name}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition hover:-translate-y-1 hover:border-primary-300 md:gap-5 md:p-5"
            >
              <div className="w-24 shrink-0 overflow-hidden rounded-md md:w-28">
                <img
                  src={s.cover}
                  alt={`${s.name}画风推荐示例`}
                  title={`BL漫画${s.name}画风`}
                  className="aspect-[3/4] h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-900 md:text-lg">{s.name}</h3>
                  <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                    {s.tagline}
                  </span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{s.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {s.traits.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between gap-2 pt-3">
                  <p className="whitespace-nowrap text-xs text-foreground-500">代表作：{s.sample}</p>
                  <a
                    href="#library"
                    className="whitespace-nowrap rounded-full border border-primary-300 px-3 py-1 text-xs text-primary-600 transition hover:bg-primary-500 hover:text-background-50"
                  >
                    查看作品
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}